import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_CLCLS_SERVICE_URL || "";
const STATUS_OK = 200;

export type UploadParams = {
    file: any;
    url: string;
};

export type Result = {
    success: boolean | null;
    data: string | null;
};

const initStatus = {
    state: "",
    message: "",
    progress: 0,
};

export const useUpload = (prefix: string, docType: string, leadId: string, open: boolean) => {
    const [file, setFile] = useState<any>(null);
    const [url, setUrl] = useState("");
    const [status, setStatus] = useState(initStatus);

    useEffect(() => setStatus(initStatus), [open]);

    const getSignedUrl = useCallback(async () => {
        const key = `${prefix}/${file.name}`;

        try {
            console.log("service url:", API_URL);
            const request = await axios.post(API_URL + "/docs/get-upload-url", {
                key,
            });

            if (request.status === STATUS_OK) {
                setUrl(request.data.message);
            } else {
                throw new Error("Upload url error! Please try again!");
            }
        } catch (e) {
            setStatus((prev) => ({
                ...prev,
                state: "error",
                message: e.message,
            }));
        }
    }, [file, prefix]);

    useEffect(() => {
        if (!file) {
            setUrl("");
        } else {
            setStatus((prev) => ({
                ...prev,
                state: "request",
                progress: 0,
            }));

            getSignedUrl();
        }
    }, [file, getSignedUrl]);

    useEffect(() => {
        if (url === "") {
            setStatus((prev) => ({ ...prev, state: "", progress: 0 }));
        }
    }, [url]);

    const notifyDocUploaded = useCallback(() => {
        axios
            .post(API_URL + "/docs/doc-upload", {
                docType,
                leadId,
            })
            .then((data) => {
                console.log("CLC service notified.", data);
            })
            .catch((err) => {
                console.log("CLC service notification failed!", err);
            });
    }, [docType, leadId]);

    const startUpload = useCallback(async () => {
        const config = {
            onUploadProgress: (event: any) => uploadProgress(event),
        };

        axios
            .put(url, file, config)
            .then((data) => {
                notifyDocUploaded();
                setStatus((prev) => ({
                    ...prev,
                    state: "success",
                }));
            })
            .catch((err) => {
                setStatus((prev) => ({
                    ...prev,
                    state: "error",
                    message: "Upload error! Please try again!",
                }));
            });
    }, [url, file, notifyDocUploaded]);

    useEffect(() => {
        if (status.state === "start" && url !== "") {
            startUpload();
        }
    }, [status, url, startUpload]);

    const upload = () => setStatus((prev) => ({ ...prev, state: "start" }));

    const uploadProgress = (event: any) => {
        setStatus((prev) => ({
            ...prev,
            state: "uploading",
            progress: Math.ceil((event.loaded / event.total) * 100) || 0,
        }));
    };

    return {
        file,
        setFile,
        status,
        upload,
    };
};
